import React from "react";
import { SmartFormInterFace, SmartTable, SmartTableNewInterface } from "soft_digi";
import { roundNumber } from "soft_digi/dist/services/CommonService";
import { SdsFsDownloadFile } from "soft_digi/dist/services/FileService";
import { SESSION_URLS } from "../../api/AdminUrls";
import { useSiteContext } from "../../contexts/SiteProvider";
import { post } from "../../services/smartApiService";
import SessionDetails from "../sessions/SessionDetails";

interface HeaderProps {
  dataIn: any;
}
const ProjectSessionReport: React.FC<HeaderProps> = ({ dataIn }) => {
  const { openModal, closeModal, setTitle } = useSiteContext();
  const onSubmit = (dt: any) => {
    let url = SESSION_URLS.GET_PDF;
    console.log("id", dt, "url = ", url);
    const subscription = post(url, { id: dt["ID"] }).subscribe((response) => {
      SdsFsDownloadFile(response.data.content, "Session Report.pdf");
    });

    return () => {
      subscription.unsubscribe();
    };
  };

  const openReport = (data: any) => {
    let options = {
      title: "Session Details(" + data["session_id"] + ")",
      content: <SessionDetails idIn={data["ID"]} />,
      className: "sd-efl-modal",
      closeBody: false,
      width: 80,
    };
    openModal(options);
  };

  const buttons = [
    {
      label: "",
      type: "icon",
      leftIcon: "fa fa-eye",
      classList: ["smart-hims-table-view-icon"],
      onClick: (data: any) => openReport(data),
      hideFunction: (data: any) => {
        return data["status"] == "completed" ? false : true;
      },
    },
    {
      label: "",
      type: "icon",
      leftIcon: "fa fa-download",
      classList: [" smart-hims-table-edit-icon"],
      onClick: (data: any) => onSubmit(data),
      hideFunction: (data: any) => {
        return data["status"] == "completed" ? false : true;
      },
    },

  ];
  const totalScore = (dataIn: any) => {
    return roundNumber(dataIn?.total_score)
  }

  const columns: SmartTableNewInterface.SmartTableNewColumnConfig[] = [
    { title: "S.NO", index: "s_no", type: "sno", width: "5" },
    { title: "Agency Name", index: "agency_name" },
    { title: "Project", index: "project_name" },
    { title: "Session Id ", index: "session_id" },
    { title: "Venue", index: "location" },
    {
      title: "Date",
      index: "session_date",
      type: "date",
      dateFormat: "DD-MM-YYYY",
      isSortable: true,
    },
    { title: "Trainer Name", index: "trainer_name" },
    { title: "No. Of Questions", index: "no_of_questions", check: false },
    { title: "Time Limit", index: "time_limit", check: false },
    // { title: "Status", index: "status" },
    // { title: "End Time", index: "end_time" },

    { title: "Total Loco Pilots", index: "total_trainees" },
    { title: "Avg score(%)", index: "total_score", valueFunction: totalScore },
    { title: "Status", index: "status" },
    {
      title: "Action",
      index: "action",
      type: "buttons",
      buttons: buttons,
      width: "5",
    },
  ];

  const tableTop: SmartTableNewInterface.SmartTableNewTopProps[] = [
    {
      type: "CUSTOM",
      widthClass: "is-6",
      custom: (
        <p className="is-size-4 has-text-weight-bold">Project Wise Session Report</p>
      ),
    },

    {
      type: "BUTTONS",
      widthClass: "is-3",
      align: "CENTER",
      buttons: [
        {
          type: "EXPORT",
          className: "smart-third-button",
        },
        {
          type: "COLUMN-FILTER",
          label: "EX",
          className: "sd-table-export",
        },
        {
          type: "FILTER",
        },
      ],
    },
    {
      type: "SEARCH",
      widthClass: "is-3",
      align: "JUSTIFY",
    },
  ];

    const filterFields: SmartFormInterFace.SmartFormElementProps[] = [
    
        {
        type: "SELECT_BOX",
        width: "12",
        name: "project_name",
        class_name: "is-small",
        element: {
          label: "Project Name",
         size: "small",
          options: [
            { value: "WR", label: "WR" },
            { value: "NCR", label: "NCR" },
            { value: "WCR", label: "WCR" },
            { value: "SCR", label: "SCR" },
            { value: "ER", label: "ER" },
          ],
        },
      },
        
     
  
    
    ];
  return (
    <>
      <div className="sd-efl-input">
        <SmartTable
          columns={columns}
          data={dataIn}
          tableTop={tableTop}
           filterFields={filterFields}
          tableProps={{
            className: "is-hoverable is-bordered smart-hims-table",
            isResponsive: true,
            searchPlaceHolder: "Search",
          }}
          allowColumnSection={true}
        // paginationProps={{
        //   pageSize: 10,
        // }}
        />
      </div>
    </>
  );
};

export default ProjectSessionReport;
